const getters = {
  isLoggedIn: state => !!state.token,
  company_id: state => state.company_id,
  authStatus: state => state.status,
  action_cable_connect: state => state.action_cable_connect,
  action_cable_message: state => state.action_cable_message,
  work_shift: state => state.work_shift,
  user: state => state.user,
  alert: state => state.alert,
  container: state => state.container,
  container_ticket: state => state.container_ticket,
  companies: state => state.companies,
  getCompanyNameById: (state) => (id) => {
    return state.companies.find(x => x.id === id)
  }
}

export default getters
